import { render, staticRenderFns } from "./filters_tabulator.vue?vue&type=template&id=37a79f7d"
import script from "./filters_tabulator.vue?vue&type=script&lang=js"
export * from "./filters_tabulator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports